export const BREAK_POINT = {
  XS: "480px",
  SM: "576px",
  MD: "768px",
  LG: "992px",
  XL: "1280px",
  XXL: "1920px",
};
